const nl = require("./language_json/nl.json");

export default nl;
